
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/startups/register-new",
      function () {
        return require("private-next-pages/startups/register-new.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/startups/register-new"])
      });
    }
  